import $ from "jquery";
import _ from "underscore";
import Backbone from "backbone";

const MessageFileArea = Backbone.Model.extend({
  defaults: {
    fileInfo: false,
  },

  reset: function () {
    this.set("fileInfo", false);
    if (this.view) {
      this.view.delegateEvents();
    }
  },

  initialize: function (attributes, options) {
    if (!window.fs) {
      try {
        const apiUrl = S.session.fileservice_url;
        // eslint-disable-next-line no-undef
        window.fs = new FileService("admentum", apiUrl, "sv_SE");
      } catch (error) {
        console.error("Could not initiate file service.");
        return;
      }
    }

    this.view = new MessageFileAreaView({
      model: this,
      template: options.template,
    });
  },

  getMetaId: function () {
    return this.get("fileInfo") ? this.get("fileInfo").uuid : "";
  },
});

const MessageFileAreaView = Backbone.View.extend({
  initialize: function (attributes) {
    this.template = attributes.template;

    this.render();

    this.listenTo(this.model, "change", this.render.bind(this));
  },

  events: {
    "click .add-file": "onAddFileClick",
    "click .remove-file": "onRemoveFileClick",
  },

  onAddFileClick(e) {
    e.preventDefault();

    // Trigger file manager area
    const $modal = $("#file-manager-modal");

    // For specific files in gallery
    const uploadAccess = FileServiceHelpers.conversation.uploadAccess(
      S.session.user.id
    );

    const selectAndCloseModal = (fileInfo) => {
      this.model.set("fileInfo", fileInfo);

      // Close modal at once for better ux.
      $modal.modal("hide");
    };

    const settings = {
      galleryPageSize: 10,
      uploadSettings: {
        onUpload: selectAndCloseModal,
        readAccess: "", // Empty since shared in the next step to the correct readAccess
      },
      fileGallerySettings: {
        onClick: selectAndCloseModal,
      },
    };

    window.fs.renderFileManager("file-manager-upload", uploadAccess, settings);

    $modal.modal();
  },

  onRemoveFileClick: function () {
    this.model.set("fileInfo", false);
  },

  render: function () {
    this.$el.html(this.template(this.model.attributes));
  },
});

const MessageDialog = Backbone.Model.extend({
  defaults: {
    draft: null,
    hasChanged: false,
    recipientUsers: [],
  },

  initialize: function (attributes) {
    const draft = attributes.conversation_draft;

    if (draft) {
      const users = _.map(draft.json_recipients.users, (user) => ({
        user_id: user.id,
        full_name: `${user.first_name} ${user.last_name}`,
      }));

      const data = {
        draft: draft,
        title: draft.title,
        content: draft.content,
        isInformation: !!draft.json_recipients.is_information,
        users: users,
        ...(draft.json_recipients.recipients
          ? { recipients: draft.json_recipients.recipients }
          : {}),
      };

      this.set(data);
    }

    this.view = new MessageDialogView({
      model: this,
    });
  },

  setupFileArea: function (template) {
    // TODO: Clean up this mess...
    if (window.fileArea) {
      window.fileArea.reset();
    } else {
      window.fileArea = new MessageFileArea({}, { template: template });
    }

    this.fileArea = window.fileArea;

    const draft = this.get("draft");
    if (draft && draft.file_info) {
      this.fileArea.set({ fileInfo: draft.file_info });
    }
  },

  hasGroupRecipients: function () {
    return !!this.get("recipients");
  },

  getFormattedRecipients: function () {
    const recipients = this.get("recipients");

    if (recipients.all && recipients.all.length) {
      const postfix = this.get("recipients").school_section
        ? ` (${this.get("recipients").school_section.name})`
        : "";
      if (_.includes(recipients.all, "users")) {
        return S.loc.RECIPIENTS_ALL_USERS + postfix;
      } else {
        const groupFormatted = {
          students: S.loc.RECIPIENTS_ALL_STUDENTS,
          parents: S.loc.RECIPIENTS_ALL_PARENTS,
          teachers: S.loc.RECIPIENTS_ALL_TEACHERS,
          principals: S.loc.RECIPIENTS_ALL_PRINCIPALS,
        };
        return (
          recipients.all
            .map(function (item) {
              return groupFormatted[item];
            })
            .join(", ") + postfix
        );
      }
    } else {
      const outputs = [];
      // students
      if (recipients.students) {
        // primary_groups
        if (recipients.students.primary_groups) {
          const names = _.map(
            recipients.students.primary_groups,
            (primaryGroupId) => recipients.names.primary_groups[primaryGroupId]
          );
          outputs.push(
            S.loc.RECIPIENTS_STUDENTS_PG.replace("[name]", names.join(", "))
          );
        }
        // schedule_groups
        if (recipients.students.schedule_groups) {
          const names = _.map(
            recipients.students.schedule_groups,
            (scheduleGroupId) =>
              recipients.names.schedule_groups[scheduleGroupId]
          );
          outputs.push(
            S.loc.RECIPIENTS_STUDENTS_SG.replace("[name]", names.join(", "))
          );
        }
        // leisure_groups
        if (recipients.students.leisure_groups) {
          const names = _.map(
            recipients.students.leisure_groups,
            (leisureGroupId) => recipients.names.leisure_groups[leisureGroupId]
          );
          outputs.push(
            S.loc.RECIPIENTS_STUDENTS_LG.replace("[name]", names.join(", "))
          );
        }
      }
      // parents
      if (recipients.parents) {
        // primary_groups
        if (recipients.parents.primary_groups) {
          const names = _.map(
            recipients.parents.primary_groups,
            (primaryGroupId) => recipients.names.primary_groups[primaryGroupId]
          );
          outputs.push(
            S.loc.RECIPIENTS_PARENTS_PG.replace("[name]", names.join(", "))
          );
        }
        // schedule_groups
        if (recipients.parents.schedule_groups) {
          const names = _.map(
            recipients.parents.schedule_groups,
            (scheduleGroupId) =>
              recipients.names.schedule_groups[scheduleGroupId]
          );
          outputs.push(
            S.loc.RECIPIENTS_PARENTS_SG.replace("[name]", names.join(", "))
          );
        }
        // leisure_groups
        if (recipients.parents.leisure_groups) {
          const names = _.map(
            recipients.parents.leisure_groups,
            (leisureGroupId) => recipients.names.leisure_groups[leisureGroupId]
          );
          outputs.push(
            S.loc.RECIPIENTS_PARENTS_LG.replace("[name]", names.join(", "))
          );
        }
      }
      // teachers
      if (recipients.teachers) {
        // primary_groups
        if (recipients.teachers.primary_groups) {
          const names = _.map(
            recipients.teachers.primary_groups,
            (primaryGroupId) => recipients.names.primary_groups[primaryGroupId]
          );
          outputs.push(
            S.loc.RECIPIENTS_TEACHERS_PG.replace("[name]", names.join(", "))
          );
        }
        // schedule_groups
        if (recipients.teachers.schedule_groups) {
          const names = _.map(
            recipients.teachers.schedule_groups,
            (scheduleGroupId) =>
              recipients.names.schedule_groups[scheduleGroupId]
          );
          outputs.push(
            S.loc.RECIPIENTS_TEACHERS_SG.replace("[name]", names.join(", "))
          );
        }
        // leisure_groups
        if (recipients.teachers.leisure_groups) {
          const names = _.map(
            recipients.teachers.leisure_groups,
            (leisureGroupId) => recipients.names.leisure_groups[leisureGroupId]
          );
          outputs.push(
            S.loc.RECIPIENTS_TEACHERS_LG.replace("[name]", names.join(", "))
          );
        }
      }
      return outputs.join(" ");
    }
  },
});

const MessageDialogView = Backbone.View.extend({
  initialize: function () {
    $("body").append(this.$el);
    this.labels = {};

    Base.get_template("message_dialog", (html) => {
      const $dialogTemplates = $(html);
      this.template = _.template(
        $dialogTemplates.find("#new-message-modal-template").html()
      );
      this.close_dialog = _.template(
        $dialogTemplates.find("#close-message-modal-template").html()
      );
      this.model.setupFileArea(
        _.template(
          $dialogTemplates.find("#new-message-filearea-template").html()
        )
      );
      this.awayUsersListTemplate = _.template(
        $dialogTemplates.find("#away-users-list-template").html()
      );
      this.usersWithMessageListTemplate = _.template(
        $dialogTemplates.find("#users-with-message-list-template").html()
      );
      this.listenTo(this.model.fileArea, "change", function () {
        this.validateDraft();
      });

      // Make sure the file-manager modal is available in the DOM
      if (!$("#file-manager-modal").size()) {
        $("body").append($dialogTemplates.find("#file-manager-modal"));
      }

      if (this.model.hasGroupRecipients()) {
        this.labels = {
          modalTitle: S.loc.INFORMATION_TITLE,
          modalButtonText: S.loc.INFORMATION_BUTTON_TEXT,
        };
      }

      this.render();
    });
  },

  events: {
    "submit .new-message-form": "onFormSubmit",
    "click #save-draft": "onClickSaveDraft",
    "keyup .new-message-form": "validateDraft",
    "change .message-is-information": "validateDraft",
    "change .message-to": "usersChange",
  },

  validateDraft: function () {
    this.model.set("hasChanged", true);

    const bodyText = Utils.formatRichTextOutput(
      tinymce.get("message-body").getContent({ format: "html" })
    );
    const title = this.$(".message-title").val().trim();
    const userIds = this.$('[name="message-to"]').val();
    const fileInfo = this.model.fileArea.get("fileInfo");

    if (
      !bodyText &&
      !title &&
      !this.model.hasGroupRecipients() &&
      !userIds &&
      !fileInfo
    ) {
      this.$("#save-draft").attr("disabled", "disabled").addClass("disabled");
    } else {
      this.$("#save-draft").removeAttr("disabled").removeClass("disabled");
    }
  },
  approved: false,
  onFormSubmit: function (e) {
    e.preventDefault();
    e.stopPropagation();

    if (this.submitting) {
      return;
    }
    this.submitting = true;

    const data = {};
    const bodyText = tinymce.get("message-body").getContent({ format: "html" });
    const title = this.$(".message-title").val().trim();
    let isInformation = this.$(".message-is-information").is(":checked");

    // Validate form
    this.$(".error-text").remove();

    let ok = true;
    let redirect = false;
    if (!this.model.hasGroupRecipients()) {
      const userIds = $('[name="message-to"]').val();
      if (!userIds.length) {
        this.$(".form-users").prepend(
          $("<span></span>")
            .addClass("error-text")
            .text(S.loc.VALIDATION_NO_USER)
        );
        ok = false;
      }
      if (userIds.split(",").length >= 2 && this.approved === false) {
        ok = false;
        this.submitting = false;
        AlertView.confirmObject({
          title: S.loc.CONFIRM_MULTIPLE_TITLE,
          message: S.loc.CONFIRM_MULTIPLE_BODY,
          callback: function () {
            this.approved = true;
            this.onFormSubmit(e);
          }.bind(this),
        });
        return;
      } else {
        data.to = userIds;
      }
    } else {
      redirect = true;
      isInformation = true;
      data.recipients = JSON.stringify(this.model.get("recipients"));
    }

    if (!bodyText) {
      this.$el
        .find(".form-body")
        .prepend(
          $("<span></span>")
            .addClass("error-text")
            .text(S.loc.VALIDATION_EMPTY_BODY)
        );
      ok = false;
    }

    const meta_id = this.model.fileArea ? this.model.fileArea.getMetaId() : "";

    if (ok) {
      data.title = title;
      data.body = bodyText;
      data.meta_id = meta_id;
      data.isInformation = isInformation;
      data.csrfmiddlewaretoken = csrf_token;

      this.$(".message-title")
        .attr("disabled", "disabled")
        .addClass("disabled");
      this.$(".message-body").attr("disabled", "disabled").addClass("disabled");
      this.$(".button-container").addClass("hidden");
      this.$(".spinner").removeClass("hidden");
      $.post(Base.get_route("create_conversation_url"), data, (response) => {
        if (response.status == 200) {
          AlertBar.showSaveSuccess(S.loc.MESSAGE_SENT);
          const conversationData = response.data;
          this.messageSent(redirect, conversationData);
        } else {
          const errorMsg =
            response.error && response.error.message
              ? response.error.message
              : response.error || S.loc.MESSAGE_ERROR;
          AlertBar.showErrorMessage(errorMsg);
          this.submitting = false;
          this.reenableForm();
        }
      }).fail((xhr, status, error) => {
        AlertBar.showErrorMessage(error);
        this.submitting = false;
        this.reenableForm();
      });
    } else {
      this.submitting = false;
    }
  },

  onClickSaveDraft: function (e) {
    e.preventDefault();
    e.stopPropagation();

    this.$(".draft-last-saved").remove();
    const draft = this.model.get("draft");

    const fileInfo = this.model.fileArea.get("fileInfo");

    const data = {
      title: this.$(".message-title").val().trim(),
      content: tinymce.get("message-body").getContent({ format: "html" }),
      csrfmiddlewaretoken: csrf_token,
      ...(fileInfo ? { file_info: JSON.stringify(fileInfo) } : {}),
    };

    if (!this.model.hasGroupRecipients()) {
      data.json_recipients = JSON.stringify({
        is_information: this.$(".message-is-information").is(":checked"),
        user_ids: JSON.parse(`[${this.$('[name="message-to"]').val()}]`),
      });
    } else {
      data.json_recipients = JSON.stringify({
        recipients: this.model.get("recipients"),
      });
    }

    let url = `${S.session.messages_url}${current_user_id}/conversation_drafts`;
    let type = "POST";
    if (draft) {
      url = `${S.session.messages_url}${current_user_id}/conversation_drafts/${draft.id}`;
      type = "PUT";
    }

    $.ajax({
      url,
      type,
      data: JSON.stringify(data),
      headers: { "User-Info": S.session.token },
      success: (response, textStatus) => {
        if (textStatus === "success") {
          if (!draft) {
            this.model.set("draft", response.conversation_draft);
          }
          this.model.set("hasChanged", false);
          this.$(".modal-body").append(
            $("<span></span>")
              .addClass("draft-last-saved")
              .text(
                S.loc.DRAFT_LAST_SAVE.replace(
                  "[name]",
                  response.conversation_draft.formatted_updated_at
                )
              )
          );

          // Special case if we're on the inbox view
          if (window.inboxInstance) {
            window.inboxInstance.draftUpdate(response.conversation_draft);
          }
        }
      },
    });
  },

  reenableForm() {
    this.$(".message-title").removeAttr("disabled").removeClass("disabled");
    this.$(".message-body").removeAttr("disabled").removeClass("disabled");
    this.$(".button-container").removeClass("hidden");
    this.$(".spinner").addClass("hidden");
  },

  messageSent(redirect, data) {
    const draft = this.model.get("draft");
    if (draft) {
      $.ajax({
        url: `${S.session.messages_url}${current_user_id}/conversation_drafts/${draft.id}`,
        headers: { "User-Info": S.session.token },
        type: "DELETE",
      });
      if (window.inboxInstance) {
        window.inboxInstance.removeDraft(draft);
      }
    }

    if (redirect) {
      // If an information dispatch was created, redirect to it directly
      document.location.href = Base.get_route(
        "conversation",
        data.conversation.id
      );
    } else {
      this.model.set("hasChanged", false);
      this.$modal.modal("hide");
      this.reenableForm();

      // Add the conversation to the header component
      if (window.HeaderMessages) {
        window.HeaderMessages.addConversation(data.conversation);
      }
    }
  },

  usersChange(e) {
    let users = this.model.get("recipientUsers");

    if (Object.hasOwn(e, "added")) {
      this.model.set("recipientUsers", [...users, e.added]);
    } else if (Object.hasOwn(e, "removed")) {
      this.model.set(
        "recipientUsers",
        users.filter((obj) => obj.id !== e.removed.id)
      );
    }
    const awayUsers = this.model
      .get("recipientUsers")
      .filter((user) => user.is_away && !user.status_message);
    if (awayUsers.length > 0) {
      this.$awayUsers.removeClass("hidden");
      this.$awayUsersList.html(this.awayUsersListTemplate({ awayUsers }));
    } else {
      this.$awayUsers.addClass("hidden");
    }

    const usersWithMessage = this.model
      .get("recipientUsers")
      .filter((user) => user.status_message);

    if (usersWithMessage.length > 0) {
      this.$usersWithMessage.removeClass("hidden");
      this.$usersWithMessageList.html(
        this.usersWithMessageListTemplate({ usersWithMessage })
      );
    } else {
      this.$usersWithMessage.addClass("hidden");
    }
  },

  render: function () {
    this.$el.html(
      this.template({
        dialog: this.model,
        labels: this.labels,
      })
    );
    this.$el.append(this.close_dialog({}));

    const $modal = this.$("#modal-new-message");
    this.$modal = $modal;
    this.$toInput = $modal.find(".message-to");
    this.$body = $modal.find(".message-body");
    this.$title = $modal.find(".message-title");
    this.$isInformation = $modal.find(".message-is-information");
    this.$awayUsers = $modal.find(".away-users");
    this.$awayUsersList = $modal.find(".away-users-list");
    this.$usersWithMessage = $modal.find(".users-with-message");
    this.$usersWithMessageList = $modal.find(".users-with-message-list");

    const $close_modal = this.$("#close-modal-new-message");

    if (this.model.fileArea.view) {
      $modal
        .find(".message-filearea-container")
        .append(this.model.fileArea.view.$el);
    }

    $modal.modal();

    $modal.on("hide.bs.modal", (e) => {
      if (this.model.get("hasChanged")) {
        e.preventDefault();
        let confirmed = false;

        $close_modal
          .modal({
            backdrop: "static",
            keyboard: false,
          })
          .on("click", "#confirm-no-save", () => {
            $close_modal.modal("hide");
            confirmed = true;
          })
          .on("click", "#confirm-save-draft", (event) => {
            this.onClickSaveDraft(event);
            $close_modal.modal("hide");
            confirmed = true;
          })
          .on("hidden.bs.modal", () => {
            $close_modal.off();
            if (confirmed) {
              this.model.set("hasChanged", false);
              $modal.modal("hide");
            }
          });
      }
    });

    $modal.on("hidden.bs.modal", () => {
      $modal.find(".new-message-form").off("submit");
      $modal.off();
      this.$toInput.select2("destroy");
      this.$el.remove();
      this.submitting = false;

      // this.model.fileArea.view.remove();
      // this.model.fileArea = null;
    });

    tinymce.remove("#message-body");
    tinymce.init({
      ...Utils.getTinyMCEOptions(),
      selector: "#message-body",
      toolbar: "bold italic underline | bullist numlist | link",
      plugins: "autolink link lists autoresize",
      setup: (editor) => {
        editor.on("input", (e) => {
          this.validateDraft(e);
        });
      },
    });

    $modal.modal();
    $modal.on("shown.bs.modal", () => {
      const model = this.model;

      this.$toInput.select2({
        placeholder: S.loc.CHOOSE_RECIPIENT,
        minimumInputLength: 1,
        multiple: true,
        ajax: {
          url: Base.get_route("communication_search"),
          dataType: "json",
          data: (term) => ({ q: term, page_limit: 20 }),
          results: (data) => ({ results: data }),
        },
        formatResult: Common.format_obj_label,
        formatSelection: Common.format_obj_label,
      });

      if (model.get("user_id") && model.get("full_name")) {
        this.$toInput.select2("data", [
          {
            id: model.get("user_id"),
            label: model.get("full_name"),
          },
        ]);
      }
      const awayUsers = this.model
        .get("recipientUsers")
        .filter((user) => user.is_away && !user.status_message);
      if (awayUsers.length > 0) {
        this.$awayUsers.removeClass("hidden");
        this.$awayUsersList.html(this.awayUsersListTemplate({ awayUsers }));
      } else {
        this.$awayUsers.addClass("hidden");
      }

      const usersWithMessage = this.model
        .get("recipientUsers")
        .filter((user) => user.status_message);

      if (usersWithMessage.length > 0) {
        this.$usersWithMessage.removeClass("hidden");
        this.$usersWithMessage.html(
          this.usersWithMessageListTemplate({ usersWithMessage })
        );
      } else {
        this.$usersWithMessage.addClass("hidden");
      }

      if (model.get("title")) {
        this.$title.val(model.get("title"));
      }

      if (model.get("content")) {
        let content = model.get("content");
        tinymce.get("message-body").setContent(content);
      }

      if (model.get("isInformation")) {
        this.$isInformation.prop("checked", model.get("isInformation"));
      }

      if (model.get("users")) {
        const initUsers = [];
        _.each(model.get("users"), function (user) {
          initUsers.push({
            id: user.user_id,
            label: user.full_name,
          });
        });
        this.$toInput.select2("data", initUsers);
      }

      if (model.get("user_id") && model.get("title")) {
        $modal.find(".message-body").focus();
      }

      $modal.find(".message-is-information").radiocheck();
    });
  },
});

export { MessageDialog };
